import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { MultipleMoveToStatusSchema } from '@app/models/orders';
import Api from '@app/services/api';
import { getFormErrorsFromResponse } from '@app/services/getFormErrorsFromResponse';

interface IParams {
  data: MultipleMoveToStatusSchema;
  processUid: string;
}

export const useMultipleMoveToStatusQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);
  const validationT = useTranslation(NSKeys.validation);

  return useMutation({
    mutationFn: async ({ data, processUid }: IParams) => {
      await Api.orders.postMultipleMoveToStatus(data, processUid);
    },
    onSuccess: async () => {
      client.invalidateQueries(['getOrdersByProcess']);
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
    },
    onError: (err) => {
      client.invalidateQueries(['getOrdersByProcess']);
      const { formMessages } = getFormErrorsFromResponse({}, err, validationT.t);
      message.open({
        type: 'error',
        content: formMessages[0] || commonT.t('error400'),
      });
    },
  });
};
